import { Box, Divider, Link, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  root: {
    minHeight: "100vh",
    background: "var(--background-color)",
    color: "var(--text-color)",
    padding: "40px 24px",
    maxWidth: 860,
    margin: "0 auto",
  },
  section: {
    marginTop: 28,
  },
  contact: {
    marginTop: 8,
    // F1 BLOCKER FIX. These links are stacked on consecutive lines. A 44px hit
    // box on a 16px link inside a 1.8 line-height (~25px) line made ADJACENT
    // hit boxes OVERLAP, and the later link in DOM order won: the bottom ~7px
    // of the visible "support@medlearnity.com" dialled the phone number
    // instead. The measuring instrument could not see it — each element's own
    // rect was >=44, so it reported 4 -> 0 truthfully while answering "is each
    // target big enough", not "does each target still receive its own taps".
    //
    // 48px line boxes give each 44px hit area its own row with clearance, which
    // is also what the audit plan asked for on this surface ("contact links to
    // list rows").
    //
    // THIS IS A VISUAL CHANGE and the earlier comment here wrongly said the
    // layout was unchanged: line-height 1.8 -> 48px grows EACH of the two
    // .contact blocks on this page (the support@/phone block and the
    // privacy/terms block) from ~50px to ~96px — page scrollHeight 1078 ->
    // 1169 as measured 2026-09-29, so +91px, not the +45px an earlier version
    // of this comment claimed. That figure was the per-block growth written
    // down as the page growth, which is the same class of error this comment
    // exists to correct, one level up.
    //
    // It reads as tappable list rows, which is the intent, but it is a taste
    // call that was made — not a no-op.
    // (The consent links on /login are also stacked; they avoid the same defect
    // only via an incidental horizontal gap. See the correction in login.scss.)
    lineHeight: "48px",
    // P3 T-3: the four contact affordances on the App-Review support surface
    // measured 16pt tall (support@, phone, Privacy Policy, Terms of Service) —
    // all four are anchors inside this block. Padding plus an equal negative
    // margin grows the hit area to 44pt without moving the text, so the
    // 1.8 line-height layout above is unchanged.
    // The hit box must be NO TALLER than the row spacing, or adjacent links
    // overlap again. 44px boxes inside 48px rows leave 4px of clearance.
    // (Keeping the earlier padding here made the box 76px tall against 48px
    // rows — taller than before the fix, and still overlapping.)
    "& a": {
      display: "inline-block",
      minHeight: 44,
      lineHeight: "44px",
    },
  },
  note: {
    background: "var(--list-item-sel-color, #f0f4ff)",
    borderLeft: "4px solid #3f51b5",
    padding: "10px 16px",
    borderRadius: 4,
    margin: "12px 0",
  },
}));

export default function SupportPage() {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Typography variant="h4" gutterBottom>
        QLearn Support
      </Typography>
      <Typography variant="body2" style={{ color: "#808080" }}>
        Support for QLearn ABSITE subscriptions, account access, and study tools.
      </Typography>
      <Divider style={{ margin: "16px 0" }} />

      <Box className={classes.section}>
        <Typography variant="h6" gutterBottom>Contact Support</Typography>
        <Typography variant="body2">
          For help with your QLearn ABSITE account, subscription access, restore purchases,
          login issues, or study workflow questions, contact Medlearnity support.
        </Typography>
        <Typography variant="body2" className={classes.contact}>
          Email: <Link href="mailto:support@medlearnity.com">support@medlearnity.com</Link><br />
          Phone: <Link href="tel:+16315402499">+1 (631) 540-2499</Link>
        </Typography>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h6" gutterBottom>Subscriptions And Purchases</Typography>
        <Typography variant="body2">
          If you subscribe through the iOS app, your purchase is managed by your Apple ID.
          You can use Restore Purchases in the app to reconnect an active App Store subscription
          to your QLearn account. If you subscribed on desktop, contact support for billing or
          access questions.
        </Typography>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h6" gutterBottom>Account Access</Typography>
        <Typography variant="body2">
          If you cannot sign in, reset your password from the QLearn login screen or email
          support with the email address tied to your QLearn account. Do not send passwords,
          payment card details, or private medical information by email.
        </Typography>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h6" gutterBottom>Educational Use</Typography>
        <Box className={classes.note}>
          <Typography variant="body2">
            QLearn ABSITE is an educational test-prep product. It is not intended for clinical
            decision support, diagnosis, treatment, or patient care.
          </Typography>
        </Box>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h6" gutterBottom>Policies</Typography>
        <Typography variant="body2" className={classes.contact}>
          <Link href="/privacy-policy">Privacy Policy</Link><br />
          <Link href="/terms">Terms of Service</Link>
        </Typography>
      </Box>

      <Box style={{ marginTop: 40, marginBottom: 16 }}>
        <Divider />
      </Box>
    </Box>
  );
}
